import React, { useState, useEffect } from 'react';

import Img1 from '../m3dasset/01copadomundo.jpg';
import Img2 from '../m3dasset/02copadomundo.jpg';
import Img3 from '../m3dasset/03halloween.png';
import Img4 from '../m3dasset/04halloween.png';
import Img5 from '../m3dasset/05halloween.png';
import Img6 from '../m3dasset/06festapatricia.png';
import Img7 from '../m3dasset/07festapatricia.png';
import Img8 from '../m3dasset/08festapatricia.png';
import Img9 from '../m3dasset/09bailepatricia.jpg';
import Img10 from '../m3dasset/10bailepatricia.jpg';
import Img11 from '../m3dasset/11bailepatricia.jpg';
import Img12 from '../m3dasset/12camaroteescritorio.jpg';
import Img13 from '../m3dasset/13camaroteescritorio.jpg';
import Img14 from '../m3dasset/14copadomundo.jpg';
/*
import Img14 from '../m3dasset/img22-studio.jpg';
import Img15 from '../m3dasset/img15-studio.jpg';
import Img16 from '../m3dasset/img16-studio.jpg';
import Img17 from '../m3dasset/img17-studio.jpg';
import Img18 from '../m3dasset/img18-studio.jpg';
import Img19 from '../m3dasset/img19-studio.jpg';
import Img20 from '../m3dasset/img20-studio.jpg';
// Img21 removed to keep columns balanced (see runtime adjustments below)

import ImgVertical01 from '../m3dasset/img1-vertical-studio.png';
import ImgVertical02 from '../m3dasset/img2-vertical-studio.png';
import ImgVertical03 from '../m3dasset/img3-vertical-studio.png';
import ImgVertical04 from '../m3dasset/img4-vertical-studio.png';
import ImgVertical05 from '../m3dasset/img5-vertical-studio.png';
import ImgVertical06 from '../m3dasset/img6-vertical-studio.png';
import ImgVertical07 from '../m3dasset/img7-vertical-studio.png';
import ImgVertical08 from '../m3dasset/img8-vertical-studio.png';
import ImgVertical09 from '../m3dasset/img9-vertical-studio.png';

import img1verticalnormal from '../m3dasset/img1verticalstudionormal.jpg';
import img2verticalnormal from '../m3dasset/img2verticalstudionormal.jpg';
import img3verticalnormal from '../m3dasset/img3verticalstudionormal.jpg';
import img4verticalnormal from '../m3dasset/img4verticalstudionormal.jpg';
import img5verticalnormal from '../m3dasset/img5verticalstudionormal.jpg';
import img6verticalnormal from '../m3dasset/img6verticalstudionormal.jpg';
import img7verticalnormal from '../m3dasset/img7verticalstudionormal.jpg';
import img8verticalnormal from '../m3dasset/img8verticalstudionormal.jpg';
import img9verticalnormal from '../m3dasset/img9verticalstudionormal.jpg';
*/


import './gallery.css';


import {MdNavigateNext, MdClose} from 'react-icons/md';
import {RiArrowLeftSLine} from 'react-icons/ri';
import { IconContext } from 'react-icons';

const images = [
  Img1,
  Img2,


  Img3,
 
  
  Img4,

  Img5,

  Img6,
  Img7,
  

 
  Img8,
  Img9,

  Img10,
 
  Img11,

 
  Img12,
  
  
  Img13,

  Img14
 
]

const imageMap = {
  0: Img1,
  1: Img2,
  2: Img3,

  3: Img4,
  4: Img5,
  5: Img6,
  
  6: Img7,
  7: Img8,
  8: Img9,

  9: Img10,
  10: Img11,
  11: Img12,

  12: Img13,
 /* 13: Img8,
  14: Img9,

  15: Img10,
  16: img7verticalnormal,
  17: Img11,

  18: img8verticalnormal,
  19: Img12,
  20: img9verticalnormal,

  21: Img13,
  22: Img14,
  23: Img15,

  24: Img16,
  25: Img17,
  26: Img18,

    27: Img19,
    28: Img20*/
};


const GalleryStudio = () => {

    const [data, setData] = useState({img: '', i: 0})  

    const viewImage = (img, i)=>{
        const modalImage = imageMap[i] || img; // Exibe a imagem mapeada ou a própria imagem se não houver mapeamento
        setData({ img: modalImage, i });
    }

    const imgAction = (action) => {
        let i = data.i;
        if (action === 'next-img') {
          setData({ img: images[i + 1], i: i + 1 });
        }
        if (action === 'previous-img') {
          setData({ img: images[i - 1], i: i - 1 });
        }
        if (!action) {
          setData({ img: '', i: 0 });
        }
      };

    return(
       
        <>
            {data.img &&
                <>
                    <div className='div-out'>
                        <img src={data.img} className='img-out' alt=''/>
                        <IconContext.Provider value={{ className: 'itprevious', color: 'white'}}>
                            <RiArrowLeftSLine 
                                onClick={() => imgAction('previous-img')}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'it' }}>
                            <MdClose onClick={() => imgAction()}/>
                        </IconContext.Provider>
                        <IconContext.Provider value={{ className: 'itnext' }}>
                                <MdNavigateNext        
                                onClick={() => imgAction('next-img')}/>
                        </IconContext.Provider>
                    </div>
                </>
            }
            <div className='gallery-outer'>
                <div className='gallery-global'>
                    <GalleryColumns images={images} onClickImage={viewImage} />
                </div>
            </div>
        </>
    );
}

function GalleryColumns({ images, onClickImage }){
    const [columns, setColumns] = useState(3);

    useEffect(()=>{
        const calc = ()=>{
            const w = window.innerWidth;
            if (w <= 430) setColumns(1);
            else if (w < 750) setColumns(2);
            else setColumns(3);
        }
        calc();
        window.addEventListener('resize', calc);
        return ()=> window.removeEventListener('resize', calc);
    },[]);

    // Heights in px
    const baseH = 320;
    const tallH = 520;
    const gap = 20; // vertical gap between items

    // specific overrides for individual items (index-based)
    const heightOverrides = {
        // reduce penultimate image height so columns align (index based)
        //28: 260,
        // Img14 (index 22) - reduce height by ~40% (approx)
        //22: 164,
        10: 520,
        11: 520,
        12: 460,

    };

    // mark some items as tall based on pattern but distribution will go to shortest column
    const items = images.map((src, i)=>({
        src,
        i,
        height: heightOverrides[i] ?? ((i % 6 === 2) ? tallH : baseH)
    }));

    // distribute greedily to keep column heights balanced
    const cols = Array.from({length: columns}, ()=>({items: [], total:0}));
    items.forEach(item=>{
        // find index of shortest column
        let idx = 0;
        for (let j=1;j<cols.length;j++){
            if (cols[j].total < cols[idx].total) idx = j;
        }
        cols[idx].items.push(item);
        cols[idx].total += item.height + gap;
    });

    return (
        <div className="columns">
            {cols.map((col, ci)=> (
                <div className="column" key={ci}>
                    {col.items.map(it=> (
                        <div key={it.i} className={`masonry-item`} style={{height: `${it.height}px`}}>
                            <img src={it.src} className='img-responsive' alt="" onClick={()=> onClickImage(it.src, it.i)} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}

export default GalleryStudio;




